import { LMS_API_KEY, TENANT_ID } from "../../../config-global";
import { ServiceResponse } from "../../types";
import LmsBuildClient from "../../../../build/buildClient";
import Base from "./base/index";
import { ITopic } from "./base/types";
import { GET_BUILD_TOPIC, GET_BUILD_TOPICS } from "./graphql";
import { GetBuildTopicInput, GetBuildTopicsInput } from "./types";

const getBuildTopics = async (
  lastUpdated: string,
  nextToken?: string
): Promise<ServiceResponse<ITopic[] | undefined>> => {
  let data: any | undefined;
  try {
    const input: GetBuildTopicsInput = {
      tenantId: TENANT_ID,
      so: lastUpdated,
      limit: 1000,
    };

    data = (
      await LmsBuildClient.request({
        method: "post",
        headers: {
          "x-api-key": LMS_API_KEY,
        },
        data: {
          query: GET_BUILD_TOPICS,
          variables: {
            input: { ...input, nextToken },
          },
        },
      })
    )?.data;

    return {
      ...data.data.getBuildTopics,
      success: !!data.data.getBuildTopics.data,
    };
  } catch (err) {
    console.error("getBuildTopics", err);
    if (data?.errors) {
      console.error("getBuildTopics", data?.errors);
    }
    return {
      success: false,
    };
  }
};

const getBuildTopic = async (
  id: string
): Promise<ServiceResponse<ITopic | undefined>> => {
  let data: any | undefined;
  try {
    const input: GetBuildTopicInput = {
      tenantId: TENANT_ID,
      id,
    };

    data = (
      await LmsBuildClient.request({
        method: "post",
        headers: {
          "x-api-key": LMS_API_KEY,
        },
        data: {
          query: GET_BUILD_TOPIC,
          variables: {
            input,
          },
        },
      })
    )?.data;

    return {
      data: data.data.getBuildTopic,
      success: !!data.data.getBuildTopic,
    };
  } catch (err) {
    console.error("getBuildTopic", err);
    if (data?.errors) {
      console.error("getBuildTopic", data?.errors);
    }
    return {
      success: false,
    };
  }
};

const TopicService = { getBuildTopics, getBuildTopic };

export default {
  ...Base,
  ...TopicService,
};
